// libs
import React, { memo } from "react";
import isEmpty from "lodash/isEmpty";
import get from "lodash/get";

//defs
import { IWidgetItems } from "shared/components/AdPlatformWidgets/components/types";

// helpers
import { getWidgetItemParams } from "shared/components/AdPlatformWidgets/Desktop/components/GenericCarousel/helpers";
import { generateSameHostUrl } from "shared/helpers/utils";

//components
import Image from "shared/components/Image";

//styles
import { Container, Anchor, Description, SubDescription } from "./styles";

// constants
import { ON_LOAD_PLACEHOLDER_COLOR } from "shared/components/AdPlatformWidgets/constants";

const DEFAULT_LABEL = "Banner";
interface IWidgetItemProps {
    widget: IWidgetItems;
    width: number;
    inventoryName: string;
    placeholderColor?: string;
    contentAlign: string;
}

function WidgetItem({
    widget,
    width,
    inventoryName,
    placeholderColor,
    contentAlign,
}: IWidgetItemProps) {
    const widgetItemParams = getWidgetItemParams(widget, width, inventoryName);
    const description = get(widget, "parameters.title") || get(widget, "parameters.title_plain");
    const subDescription = get(widget, "parameters.description", "");

    const Element = (
        <div style={{ width: `${width}px` }}>
            <Image
                alt={description || subDescription || DEFAULT_LABEL}
                src={widgetItemParams.source}
                width={width}
                aspectRatio={widgetItemParams.aspect_ratio}
                srcSet={`${widgetItemParams.source} 1x, ${widgetItemParams.originalSource} 2x`}
                placeholderColor={placeholderColor}
                onLoadPlaceholderColor={ON_LOAD_PLACEHOLDER_COLOR}
            />
            {!isEmpty(description) && <Description align={contentAlign}>{description}</Description>}
            {!isEmpty(subDescription) && (
                <SubDescription align={contentAlign}>{subDescription}</SubDescription>
            )}
        </div>
    );

    if (isEmpty(widgetItemParams.action_url)) {
        return <Container>{Element}</Container>;
    }

    return (
        <Anchor
            target="_blank"
            href={generateSameHostUrl(widgetItemParams.action_url)}
            aria-label={description || subDescription || DEFAULT_LABEL}
        >
            {Element}
        </Anchor>
    );
}

export default memo(WidgetItem);
